"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeRecords = mergeRecords;
const api_delete_js_1 = require("../dtos/api-delete.js");
function mergeRecords(existing, input, mergeFn) {
    if (!input) {
        return existing;
    }
    if (input.set) {
        return input.set;
    }
    const merged = { ...existing };
    if (input.upsert) {
        for (const [key, incomingValue] of Object.entries(input.upsert)) {
            if (incomingValue === api_delete_js_1.API_DELETE) {
                delete merged[key];
            }
            else {
                merged[key] = incomingValue;
            }
        }
    }
    if (input.update) {
        for (const [key, incomingValue] of Object.entries(input.update)) {
            const existingValue = merged[key];
            if (incomingValue === api_delete_js_1.API_DELETE) {
                delete merged[key];
            }
            else if (existingValue !== undefined) {
                merged[key] = mergeFn(existingValue, incomingValue);
            }
        }
    }
    if (input.create) {
        for (const [key, incomingValue] of Object.entries(input.create)) {
            if (merged[key] !== undefined) {
                continue;
            }
            merged[key] = incomingValue;
        }
    }
    return merged;
}
//# sourceMappingURL=merge-records.js.map